





















import Enumerable from "linq";
import { ElTree } from "element-ui/types/tree";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { FormatReferenceTreeAddFormatTreeDialogModel } from ".";
import {
  FormatReference,
  IFormatReferenceTreeNode,
  IFormatReferenceTreeData
} from "../../../../../domain/format";
import { Directory } from "../../../../../domain/drawing";
import { DirectoryTreeNodesFactory } from "../../../../system/utilities/DirectoryTreeNodesFactory";
import { FormatTreeNodeUtility } from "../utilities";
import { FormatTreeSourceSelectableMixin } from ".././mixins";

/**
 * TODO: components/settings/dialogsにほぼ同じ処理があるのでどこかのタイミングで統一したほうが良い
 */
@Component({
  components: {
  }
})
export default class FormatReferenceTreeAddFormatTreeSelector extends Mixins(FormatTreeSourceSelectableMixin) {
  private static readonly _nodeUtility = new FormatTreeNodeUtility();

  data(): any {
    return {
      selectedNode: null as IFormatReferenceTreeNode,
    };
  }
  selectedNode: IFormatReferenceTreeNode;

  @Prop()
  filter: (source: FormatReference | Directory<string, FormatReference>) => boolean;

  @Watch("filter")
  onFilterUpdated(
    newValue: (source: FormatReference | Directory<string, FormatReference>) => boolean,
    oldValue: (source: FormatReference | Directory<string, FormatReference>) => boolean
  ): void {
    if (this.getTreeComponent()) {
      this.getTreeComponent().filter(newValue);
    }
    this.updateEditingSource();
  }

  filterNode(filter: (source: FormatReference | Directory<string, FormatReference>) => boolean, data: IFormatReferenceTreeData): boolean {
    // 現状では「すべて」はフラットなので末端フォルダのみの対応で足りている
    const entities = data.source instanceof Directory ? data.source.entities : [];
    return (entities instanceof Array)
      && (0 < entities.length)
      && filter(data.source)
      && Enumerable.from(entities).any(e => filter(e));
  }

  get isLoaded(): boolean {
    return (this.nodes !== null)
        && (this.nodes !== undefined)
        && (0 < this.nodes.length);
  }

  get nodes(): IFormatReferenceTreeData[] {
    const factory = new DirectoryTreeNodesFactory<string, FormatReference>();
    return factory.create(this.directories);
  }

  get treeDialogModel(): FormatReferenceTreeAddFormatTreeDialogModel<FormatReference> {
    return this.editingSource;
  }

  get selectedDirectory(): Directory<string, FormatReference> {
    return this.treeDialogModel.selectedDirectory;
  }

  set selectedDirectory(value: Directory<string, FormatReference>) {
    this.treeDialogModel.selectedDirectory = value;
  }

  get selectedFormats(): FormatReference[] {
    return this.treeDialogModel.selectedFormats;
  }

  set selectedFormats(value: FormatReference[]) {
    this.treeDialogModel.selectedFormats = value;
  }

  get selectedOfAllFormats(): FormatReference[] {
    return this.treeDialogModel.selectedOfAllFormats;
  }

  set selectedOfAllFormats(value: FormatReference[]) {
    this.treeDialogModel.selectedOfAllFormats = value;
  }

  getTreeComponent(): ElTree<string, IFormatReferenceTreeData> {
    return this.$refs.tree as ElTree<string, IFormatReferenceTreeData>;
  }

  nodeClass(node: IFormatReferenceTreeNode): string {
    return FormatReferenceTreeAddFormatTreeSelector._nodeUtility.nodeIconClass(node);
  } 

  nodeLabel(node: IFormatReferenceTreeNode): string {
    return node.label;
  } 

  handleNodeClicked(node: IFormatReferenceTreeData, nodeProperty: IFormatReferenceTreeNode, nodeSelf: any): void {
    this.selectedNode = nodeProperty;
  }

  created(): void {
    this.updateEditingSource();
  }

  @Watch("selectedNode")
  onSelectedNodeUpdated(newValue: IFormatReferenceTreeNode, oldValue: IFormatReferenceTreeNode) {
    this.updateEditingSource();
  }

  @Watch("directories")
  onDirectoriesUpdated(newValue: Directory<string, FormatReference>[], oldValue: Directory<string, FormatReference>[]) {
    this.updateEditingSource();
  }

  updateEditingSource(): void {
    // フィルタっぽい動作なのでフィルタとして実装した方がよい気がするが、今から対応するのは当りがデカいのでフォーマットの配列を返す実装を維持.
    this.selectedDirectory = (this.selectedNode && this.selectedNode.data && this.selectedNode.data.source instanceof Directory)
      ? this.selectedNode.data.source
      : null;
    this.selectedOfAllFormats = this.selectedDirectory
      ? this.selectedDirectory instanceof Directory
        ? this.extractDirectoryEntities(this.selectedDirectory)
        : this.extractDirectoriesEntities(this.directories)
      : null;
    this.selectedFormats = null;
  }

  extractDirectoryEntities(source: Directory<string, FormatReference>): FormatReference[] {
    return Enumerable.from(source.entities)
      .where(e => !this.filter || this.filter(e))
      .concat(this.extractDirectoriesEntities(source.nodes))
      .toArray();
  }

  extractDirectoriesEntities(source: Directory<string, FormatReference>[]): FormatReference[] {
    return Enumerable.from(source)
      .where(d => !this.filter || this.filter(d))
      .select(d => this.extractDirectoryEntities(d))
      .aggregate([], (s, e) => s.concat(e));
  }
}
